import React, { useState, useEffect } from 'react'
import { List, ListItem, ListItemText, Divider, Button, to } from "@material-ui/core";
import "../styles/MemberSideNav.css"
import { useSelector, useDispatch } from 'react-redux';
import { userActions } from '../actions/user.actions'
import { useHistory } from 'react-router-dom'
import SideNav from './SideNav';

function MemberSideNav(props, state) {
  const [wid, setWid] = useState("");
  const LoginReducer = useSelector(state => state.LoginReducer)
  const dispatch = useDispatch();
  const history = useHistory();
  const [hide, setHide] = useState(false)
  const [display,setdisplay]=useState('')
  const [bg,setBg]=useState('')

  useEffect(() => {
    //   if(!LoginReducer.loggedIn){
    //     history.push("/membership_login")
    //   }
    console.log("useeffect")
  }, [wid,display])

  const openSidenav = () => {
    setWid("25%")
    setHide(false)
    setdisplay('block')
    setBg('#4869B0')
    
    console.log("Width", wid);
    return;
  }
  const closeSidenav = () => {
    setWid("10%")
    setHide(true)
    setdisplay('none')
    setBg('white')
    console.log("Width", wid);
    return;
  }

  function ListItemLink(props) {
    console.log("ListItem")
    return <ListItem button component="a" {...props} />;
  }

  const handleLogOut = () => {
    dispatch(userActions.logout())
    history.push("/membership_login")

  }
  const result = JSON.parse(localStorage.getItem("result"))
  const handleView = async (value) => {
    history.push(`/member/mydetials/${value}`);
    closeSidenav()
  }
const memberdash=()=>{
  history.replace("/member/deshboard" )
  closeSidenav()
}
const membernote=()=>{
  history.replace("/member/NoticeMemberPage")
  closeSidenav()
}
const memberkit=()=>{
  history.replace("/member/MemberKit")
  closeSidenav()
}
  const sidenav = JSON.parse(localStorage.getItem("nav"))

  return (
    <>
      <div className="container">
        <div className="sidenav" style={{ width: wid,backgroundColor:bg }}>
          {hide ? <button onClick={openSidenav} ><i class="fa fa-navicon  openbtn" ></i></button>: 
          <button onClick={closeSidenav}><i class="fa fa-navicon  closebtn"  ></i></button>
         }
          <List component="nav" style={{display:display,position:'relative',top:'40px',right:'19px'}}>
            <ListItemLink className="listNav"  onClick={memberdash}  button >
              <ListItemText primary="Home"  />
            </ListItemLink>
            <ListItemLink className="listNav" onClick={() => handleView(result._id)} button>
              <ListItemText primary="My Details" />
            </ListItemLink>
            <ListItemLink className="listNav"  onClick={membernote} button>
              <ListItemText primary="Notices" />
            </ListItemLink>
            <ListItemLink className="listNav" onClick={memberkit} button>
              <ListItemText primary="Member Kit" />
            </ListItemLink>
            <ListItemLink className="listNav" href="/member/member_resetPass" button>
              <ListItemText primary="Reset Password" />
            </ListItemLink>
            <ListItemLink className="listNav" onClick={handleLogOut} button>
              <ListItemText primary="Log Out"  />
            </ListItemLink>
          </List>
        </div>
      </div>
    </>

  )
}

export default MemberSideNav;
